const queries = {

  login() {
    return '/api/login';
  },
  recoverPassword() {
    return '/api/passwords/recover';
  },
  resetPassword() {
    return '/api/passwords/reset';
  },
  renewPassword() {
    return '/api/passwords/renew';
  },
  createPassword() {
    return '/api/passwords';
  },

  userProfile(emailHash) {
    return `https://en.gravatar.com/${emailHash}.json`;
  },
  userAvatar(emailHash) {
    return `https://www.gravatar.com/avatar/${emailHash}`;
  },
  user(userId) {
    return `/api/users/${userId}`;
  },
  employeeRole() {
    return '/api/user-merchant/employee/role';
  },
  myUser() {
    return '/api/users/me';
  },
  myCompany() {
    return '/api/users/me/company';
  },
  userAction(userId, action) {
    return `/api/users/${userId}/actions/${action}`;
  },
  userChangePassword() {
    return '/api/users/me/password';
  },
  userAuditLogs(pagination, filtering) {
    return this.applyAll('/api/audit-logs/users', pagination, filtering);
  },
  taskExecutions(pagination, filtering, parameters) {
    return this.applyAll('/api/task-executions', pagination, filtering, parameters);
  },
  taskExecutionsAsCsv(pagination, filtering, timeZone) {
    return this.applyAll('/api/task-executions.csv', pagination, filtering, { timeZone });
  },
  users(pagination, filtering) {
    return this.applyAll('/api/users', pagination, filtering);
  },
  usersAsCsv(pagination, filtering, timeZone) {
    return this.applyAll('/api/users.csv', pagination, filtering, { timeZone });
  },
  customers(pagination, filtering) {
    return this.applyAll('/api/customers', pagination, filtering);
  },
  customersAsCsv(pagination, filtering, timeZone) {
    return this.applyAll('/api/customers.csv', pagination, filtering, { timeZone });
  },
  customerCards(customerId) {
    return `/api/customers/${customerId}/cards`;
  },
  customer(customerId) {
    return `/api/customers/${customerId}`;
  },
  customerAction(customerId, action) {
    return `/api/customers/${customerId}/actions/${action}`;
  },
  customerEvents(customerId, pagination, filtering) {
    return this.applyAll(`/api/customers/${customerId}/actions`, pagination, filtering);
  },

  cardAction(cardId, action) {
    return `/api/cards/${cardId}/actions/${action}`;
  },

  screening(pagination, filtering) {
    return this.applyAll('/api/screening', pagination, filtering);
  },
  screeningAsCsv(pagination, filtering, timeZone) {
    return this.applyAll('/api/screening.csv', pagination, filtering, { timeZone });
  },

  transactions(pagination, filtering) {
    return this.applyAll('/api/transactions', pagination, filtering);
  },
  transactionsAsCsv(pagination, filtering, timeZone) {
    return this.applyAll('/api/transactions.csv', pagination, filtering, { timeZone });
  },
  transactionsLimitAsCsv(pagination, filtering, dateFrom, dateTo) {
    return this.applyAll('/api/transactions.csv', pagination, filtering, { dateFrom, dateTo });
  },
  soapLogs(pagination, filtering) {
    return this.applyAll('/api/soap-logs', pagination, filtering);
  },
  mpiLogs(pagination, filtering) {
    return this.applyAll('/api/mpi-logs', pagination, filtering);
  },
  transaction(transactionId) {
    return `/api/transactions/${transactionId}`;
  },
  transactionByQuery(filtering) {
    return this.applyFilteringOnly('/api/transaction', filtering);
  },
  transactionLog(transactionId) {
    return `/api/transactions/${transactionId}/logs`;
  },
  transactionAction(transactionId, action) {
    return `/api/transactions/${transactionId}/actions/${action}`;
  },
  consumerCreditsRefunds(pagination, filtering) {
    return this.applyAll('/api/financing/consumer-credits-refunds', pagination, filtering);
  },
  consumerCreditsRefundCancellation(refundRequestId) {
    return `/api/financing/consumer-credits/refund-requests/${refundRequestId}/cancel`;
  },
  consumerCredits(pagination, filtering) {
    return this.applyAll('/api/financing/consumer-credits', pagination, filtering);
  },
  consumerCreditsAsCsv(pagination, filtering, timeZone) {
    return this.applyAll('/api/financing/consumer-credits.csv', pagination, filtering, { timeZone });
  },
  creditOrdersAsCsv(pagination, filtering, timeZone) {
    return this.applyAll('/api/financing/credit-orders.csv', pagination, filtering, { timeZone });
  },
  authenticationsAsCsv(pagination, filtering, timeZone) {
    return this.applyAll('/api/financing/authentications.csv', pagination, filtering, { timeZone });
  },
  offersAsCsv(pagination, filtering, timeZone) {
    return this.applyAll('/api/financing/offers.csv', pagination, filtering, { timeZone });
  },
  signaturesAsCsv(pagination, filtering, timeZone) {
    return this.applyAll('/api/financing/signatures.csv', pagination, filtering, { timeZone });
  },
  consumerCredit(consumerCreditId) {
    return `/api/financing/consumer-credits/${consumerCreditId}`;
  },
  consumerCreditRefundRequests(consumerCreditId) {
    return `/api/financing/consumer-credits/${consumerCreditId}/refund-requests`;
  },

  editConsumerCreditComment(consumerCreditId) {
    return `/api/financing/consumer-credits/${consumerCreditId}/edit-comment`;
  },
  setConsumerCreditResponsiblePerson(consumerCreditId) {
    return `/api/financing/consumer-credits/${consumerCreditId}/edit-responsible-person`;
  },
  confirmConsumerCredit(consumerCreditId) {
    return `/api/financing/consumer-credits/${consumerCreditId}/confirm`;
  },
  creditOrders(pagination, filtering) {
    return this.applyAll('/api/financing/credit-orders', pagination, filtering);
  },
  creditOffers(pagination, filtering) {
    return this.applyAll('/api/financing/offers', pagination, filtering);
  },
  creditAuthentications(pagination, filtering) {
    return this.applyAll('/api/financing/authentications', pagination, filtering);
  },
  creditSignatures(pagination, filtering) {
    return this.applyAll('/api/financing/signatures', pagination, filtering);
  },

  purchases(pagination, filtering) {
    return this.applyAll('/api/purchases', pagination, filtering);
  },
  purchasesAsCsv(pagination, filtering, timeZone) {
    return this.applyAll('/api/purchases.csv', pagination, filtering, { timeZone });
  },
  purchase(purchaseId) {
    return `/api/purchases/${purchaseId}`;
  },
  recurrings(pagination, filtering) {
    return this.applyAll('/api/recurring', pagination, filtering);
  },
  recurringAsCsv(pagination, filtering, timeZone) {
    return this.applyAll('/api/recurring.csv', pagination, filtering, { timeZone });
  },
  recurring(recurringId) {
    return `/api/recurring/${recurringId}`;
  },
  purchaseAction(purchaseId, action) {
    return `/api/purchases/${purchaseId}/actions/${action}`;
  },
  exchangeXmls(pagination, filtering) {
    return this.applyAll('/api/exchange-logs', pagination, filtering);
  },
  exchangeXmlsCsv(pagination, filtering, timeZone) {
    return this.applyAll('/api/exchange-logs.csv', pagination, filtering, { timeZone });
  },

  merchants(pagination, filtering) {
    return this.applyAll('/api/merchants', pagination, filtering);
  },
  merchantsAsCsv(pagination, filtering, timeZone) {
    return this.applyAll('/api/merchants.csv', pagination, filtering, { timeZone });
  },
  merchant(merchantId) {
    return `/api/merchants/${merchantId}`;
  },
  userMerchant() {
    return '/api/user-merchant';
  },
  userMerchantOrderVerificationUrl() {
    return '/api/user-merchant/order-verification-callback';
  },
  userMerchantPaymentNotificationUrl() {
    return '/api/user-merchant/payment-notification-callback';
  },
  userMerchantDeliveryCostCalculationUrl() {
    return '/api/user-merchant/delivery-cost-calculation-callback';
  },
  userMerchantCertificate() {
    return '/api/user-merchant/certificate';
  },
  merchantBackground(merchantId) {
    return `/api/merchants/${merchantId}/background`;
  },
  disableMerchantCertificate() {
    return '/api/user-merchant/certificate/disable';
  },
  disableCertificate(merchantId) {
    return `/api/merchants/${merchantId}/certificate/disable`;
  },
  toggleMerchantFeature(merchantId, featureName) {
    return `/api/merchants/${merchantId}/features/${featureName}`;
  },
  userMerchantCertificateById(certificateId) {
    return `/api/user-merchant/certificate/${certificateId}`;
  },
  userMerchantCertificates(pagination, filtering) {
    return this.applyAll('/api/user-merchant/certificates', pagination, filtering);
  },
  userMerchantApiKey() {
    return '/api/user-merchant/api-key';
  },
  merchantCertificate(merchantId) {
    return `/api/merchants/${merchantId}/certificateInfo`;
  },
  merchantCertificates(merchantId) {
    return `/api/merchants/${merchantId}/certificates`;
  },
  merchantCertificateById(merchantId, certificateId) {
    return `/api/merchants/${merchantId}/certificate/${certificateId}`;
  },
  merchantApiKey(merchantId) {
    return `/api/merchants/${merchantId}/api-key-info`;
  },
  merchantEmployees(merchantId, pagination, filtering) {
    return this.applyAll(`/api/merchants/${merchantId}/employees`, pagination, filtering);
  },
  merchantEmployee() {
    return '/api/user-merchant/employee';
  },
  userMerchantEmployees(pagination, filtering) {
    return this.applyAll('/api/user-merchant/employees', pagination, filtering);
  },
  userMerchantEmployeeDelete(employeeId) {
    return this.applyAll(`/api/user-merchant/employee/${employeeId}`);
  },

  serviceProviderCertificate() {
    return '/api/service-provider/certificateInfo';
  },
  serviceProviderPublicIp() {
    return '/api/service-provider/public-ip';
  },

  businessDays(from, to, filtering) {
    return this.applyFiltering(`/api/reports/business-days/?fromDate=${from}&toDate=${to}`, filtering);
  },
  permissions() {
    return '/api/permissions';
  },
  rules() {
    return '/api/settings/rules';
  },
  rule(ruleId) {
    return `/api/settings/rules/${ruleId}`;
  },
  rulesEvaluationResults(pagination, filtering) {
    return this.applyAll('/api/rules-evaluation-results', pagination, filtering);
  },
  binRanges(pagination, filtering) {
    return this.applyAll('/api/settings/bin-ranges', pagination, filtering);
  },
  binRangesAsCsv(pagination, filtering, timeZone) {
    return this.applyAll('/api/settings/bin-ranges.csv', pagination, filtering, { timeZone });
  },
  metaData() {
    return '/api/settings/meta-data';
  },
  merchantMccCodes() {
    return '/api/enums/mcc';
  },
  merchantProductCategories() {
    return '/api/enums/product-categories';
  },
  countries() {
    return '/api/enums/countries';
  },
  shippingMethods() {
    return '/api/shipping/methods';
  },
  merchantShippingMethods(pagination, filtering) {
    return this.applyAll('/api/merchant/shipping/methods', pagination, filtering);
  },
  merchantShippingMethod(id) {
    return `/api/merchant/shipping/method/${id}`;
  },
  merchantDeliveryMethodsByMerchant(merchantId, pagination, filtering) {
    return this.applyAll(`/api/merchants/${merchantId}/delivery-methods/`, pagination, filtering);
  },
  getDeliveryMethodsForMerchant() {
    return '/api/merchants/delivery/methods/';
  },
  addNewMerchantDeliveryMethod() {
    return '/api/merchant/delivery/method';
  },
  addMerchantShippingMethod() {
    return '/api/merchant/shipping/method';
  },
  updateMerchantShippingMethod() {
    return '/api/merchant/shipping/method';
  },
  disableMerchantShippingMethod(id) {
    return `/api/merchant/shipping/method/${id}/disable`;
  },
  activateMerchantShippingMethod(id) {
    return `/api/merchant/shipping/method/${id}/activate`;
  },
  merchantWidgets(pagination, filtering) {
    return this.applyAll('/api/widgets', pagination, filtering);
  },
  merchantWidget(widgetId) {
    return `/api/widgets/${widgetId}`;
  },
  disableMerchantWidget(widgetId) {
    return `/api/widgets/${widgetId}/disable`;
  },
  activateMerchantWidget(widgetId) {
    return `/api/widgets/${widgetId}/activate`;
  },
  createMerchantWidget() {
    return '/api/widgets';
  },
  merchantOrders(pagination, filtering) {
    return this.applyAll('/api/orders', pagination, filtering);
  },
  merchantOrder(orderId) {
    return `/api/orders/${orderId}`;
  },
  approveOrder(orderId) {
    return `/api/orders/${orderId}/approve`;
  },
  rejectOrder(orderId) {
    return `/api/orders/${orderId}/reject`;
  },
  merchantOrderItems(orderId) {
    return `/api/orders/${orderId}/items`;
  },
  version() {
    return 'VERSION';
  },
  commitHash() {
    return 'COMMITHASH';
  },
  announcements() {
    return '/api/announcements';
  },
  customersAnnouncements(pagination, filtering) {
    return this.applyAll('/api/customers-announcements', pagination, filtering);
  },
  customersAnnouncement(announcementId) {
    return `/api/customers-announcements/${announcementId}`;
  },
  deliveryCompanies(pagination, filtering) {
    return this.applyAll('/api/delivery/companies', pagination, filtering);
  },
  deliveryCompany(id) {
    return `/api/delivery/companies/${id}`;
  },
  deliveryCompanyDeliveryMethods(id, pagination, filtering) {
    return this.applyAll(`/api/delivery/companies/${id}/methods`, pagination, filtering);
  },
  deliveryCompanyDeliveryMethod(companyId, methodId) {
    return `/api/delivery/companies/${companyId}/methods/${methodId}`;
  },
  deliveryMethodPickupPoints(methodId, pagination, filtering) {
    return this.applyAll(`/api/delivery/methods/${methodId}/pickup-points/`, pagination, filtering);
  },
  createDeliveryMethodPickupPoint(methodId) {
    return `/api/delivery/methods/${methodId}/pickup-points/`;
  },
  deliveryMethodPickupPoint(methodId, pickupPointId) {
    return `/api/delivery/methods/${methodId}/pickup-points/${pickupPointId}`;
  },
  merchantDeliveryMethods(methodId, pagination, filtering) {
    return this.applyAll(`/api/delivery/methods/${methodId}/companies/`, pagination, filtering);
  },
  merchantDeliveryMethod(methodId, merchantDeliveryMethodId) {
    return `/api/delivery/methods/${methodId}/merchant-method/${merchantDeliveryMethodId}`;
  },
  merchantsForDeliveryMethods() {
    return '/api/delivery/merchants';
  },
  csvRecordsLimit() {
    return '/api/csv/records-limit';
  },
  financingProducts() {
    return '/api/financing-products';
  },
  merchantFinancingProducts(merchantId) {
    return `/api/financing-products/${merchantId}`;
  },
  deleteMerchantFinancingProduct(merchantProductId) {
    return `/api/financing-products/${merchantProductId}`;
  },
  updateMerchantFinancingProducts(merchantId) {
    return `/api/financing-products/${merchantId}`;
  },

  financingInstitution(financingInstitutionId) {
    return `/api/financing/financing-institutions/${financingInstitutionId}`;
  },
  toggleFinancingInstitutionFeature(financingInstitutionId, featureName) {
    return `/api/financing/financing-institutions/${financingInstitutionId}/features/${featureName}`;
  },
  financingInstitutions(pagination, filtering) {
    return this.applyAll('/api/financing/financing-institutions', pagination, filtering);
  },
  financingInstitutionsAsCsv(pagination, filtering, timeZone) {
    return this.applyAll('/api/financing/financing-institutions.csv', pagination, filtering, { timeZone });
  },
  merchantFinancingInstitutions(merchantId) {
    return `/api/merchants/${merchantId}/financing-institutions`;
  },
  updateMerchantFinancingInstitution(merchantId, merchantSupportedFiId) {
    return `/api/merchants/${merchantId}/financing-institutions/${merchantSupportedFiId}`;
  },

  applyAll(url, pagination, filtering, parameters) {
    let result = url;
    result = this.applyPaging(result, pagination);
    result = this.applyFiltering(result, filtering);
    result = this.applyParameters(result, parameters);
    return result;
  },

  applyPaging(url, pagination) {
    if (pagination === undefined) {
      return url;
    }

    const { page, rowsPerPage, sortBy, descending } = pagination;
    let order = 'ASC';
    if (descending) {
      order = 'DESC';
    }

    return `${url}?page=${page - 1}&size=${rowsPerPage}&sort=${sortBy},${order}`;
  },
  applyFiltering(url, filtering) {
    if (filtering === undefined) {
      return url;
    }

    let result = url;
    Object.keys(filtering)
      .forEach((prop) => {
        const filterValue = typeof filtering[prop] === 'string' ? filtering[prop].trim() : filtering[prop];
        if (filterValue !== '') {
          result = `${result}&f_${prop}=${this.encode(filterValue)}`;
        }
      });
    return result;
  },
  applyFilteringOnly(url, filtering) {
    if (filtering === undefined) {
      return url;
    }

    let result = `${url}?`;
    Object.keys(filtering)
      .forEach((prop) => {
        const filterValue = filtering[prop].trim();
        if (filterValue !== '') {
          result = `${result}${prop}=${this.encode(filterValue)}&`;
        }
      });
    return result.substr(0, result.length - 1);
  },
  applyParameters(url, parameters) {
    if (!parameters) {
      return url;
    }

    let result = url;
    Object.keys(parameters)
      .forEach((prop) => {
        const paramValue = parameters[prop].trim();
        if (paramValue !== '') {
          result = this.addUrlParam(result, prop, paramValue);
        }
      });
    return result;
  },
  getFiltering(vm) {
    return Object.keys(vm.$route.query)
      .filter(k => k.startsWith('f_'))
      .map(k => k.substr(2, k.length))
      /* eslint-disable no-param-reassign */
      .reduce((accumulator, key) => {
        accumulator[key] = vm.$route.query[`f_${key}`];
        return accumulator;
      }, {});
  },
  addUrlParam(url, paramName, paramValue) {
    let separator = '?';
    if (url.includes('?')) {
      separator = '&';
    }
    return `${url}${separator}${paramName}=${paramValue}`;
  },
  encode(value) {
    return encodeURIComponent(value);
  },

};

export default queries;



// WEBPACK FOOTER //
// ./src/utils/queries.js